import { Button, ButtonProps } from '@slal/ui/buttons';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useAnalytics } from '~/hooks';

export const BackButton = ({ children, route, ...otherProps }: ButtonProps & { route: string }) => {
    const { pushEvent } = useAnalytics();
    const navigate = useNavigate();

    const handleClick = useCallback(() => {
        navigate(route);
        pushEvent({ eventLabel: 'Back button click' });
    }, [navigate, pushEvent, route]);

    return (
        <Button role="link" onClick={handleClick} size="large" type="button" variant="outline" {...otherProps}>
            {children || `Back`}
        </Button>
    );
};
